/** Shared hover treatment for inactive filter and sort dropdown triggers. */
export const filterTriggerHover =
  '[@media(hover:hover)]:hover:border-gray-300 [@media(hover:hover)]:hover:bg-gray-50';

/** Shared keyboard-focus treatment for filter and sort triggers: border-colour shift, no ring or outline. */
export const filterTriggerFocus = 'outline-none focus-visible:border-primary-600';
